module.exports = __webpack_public_path__ + "img/Plus.4d84db0d.svg";